import { requestBaseService } from './index'

export const getTicker = () => {
  return requestBaseService({
    url: 'console/ex/v1/tickers/',
    method: 'get',
  })
}

const Ticker = {
  getTicker
}

export default Ticker
